import { API, API_VIDEOS } from '../constants/api';
import request from './api';

const URL_IMAGE = `${API}images/images`;
const URL_FILE = `${API}files/files`;

export const getImageLink = clientImagePath =>
  clientImagePath ? `${URL_IMAGE}${clientImagePath}` : null;

export const getImageVideoPath = (path, size, nameFile) => {
  const regex = /\.[a-zA-Z0-9]+$/;
  const extensionFile = regex.test(nameFile) ? regex.exec(nameFile)[0] : '.jpg';
  return `${URL_IMAGE}${path}${
    !size ? '128x72' : size
  }${extensionFile}?${Date.now()}`;
};

export const getFile = url => URL_FILE + url;

export const videoUrl = id => request(`${API_VIDEOS}${id}`, { method: 'GET' });

export const totalElements = n => {
  const total = [];
  for (let i = 1; i <= n; i += 1) {
    total.push(i);
  }
  return total;
};
